import { z } from "zod";

/**
 * Why `catalog.artists.getProfileById` answered NOT_FOUND, carried on the
 * tRPC error's `data.reason`. Direct profiles require an existing, non-excluded
 * identity, not a valid album or recordings in the visitor's territory.
 * Keep the original enum values so older clients retain their unavailable view.
 */
export const artistProfileMissReasonSchema = z.enum([
  // Legacy server reason; current direct-profile lookup no longer emits it.
  "outside_territory",
  // Existing identity with no available direct profile, including manual
  // exclusion. The historical name is retained for wire compatibility.
  "no_catalog",
  // The identity does not exist; still reported as a broken reference.
  "not_found",
]);
export type ArtistProfileMissReason = z.infer<
  typeof artistProfileMissReasonSchema
>;

/** Reasons the visitor should read as "not available", not as an error. */
export const ARTIST_PROFILE_UNAVAILABLE_REASONS: ReadonlySet<ArtistProfileMissReason> =
  new Set(["outside_territory", "no_catalog"]);

export const ARTIST_PROFILE_MISS_MESSAGE: Record<
  ArtistProfileMissReason,
  string
> = {
  outside_territory: "Artist not available in your territory",
  no_catalog: "Artist profile is unavailable",
  not_found: "Artist not found",
};
